import type { ViewData } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/common/multisection.data';
import { getHeroAndTextSubtype } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/common/section-gaps/hero-and-text-gaps';
import {
  getGapHeightWithNextSection,
  getGapHeightWithPreviousSection,
  getNextSection,
  getPreviousSection,
} from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/common/section-gaps/section-gap-calculators';
import { pushGapToColumn } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/common/sections.common';

import type { BrandConcessionContentSectionDTO } from '~gateways/ownable.dtos';

export function addGapBeforeSectionWithSectionId(
  viewData: ViewData,
  section: BrandConcessionContentSectionDTO
): ViewData {
  let gapHeight = getGapHeightWithPreviousSection(viewData, section);

  // If I am HeroAndText with Hero image I get no top padding (all is applied by previous section)
  if (section.template === 'HeroAndText') {
    const subtype = getHeroAndTextSubtype(section);

    if (subtype === 'HeroAndText' || subtype === 'HeroNoText') {
      gapHeight = 0;
    }
  }

  // If I'm not HeroAndText and section before me is Hero Image only, then I have to apply all the gap between us
  if (section.template !== 'HeroAndText') {
    const previousSection = getPreviousSection(viewData, section);

    if (previousSection?.template === 'HeroAndText') {
      const subtype = getHeroAndTextSubtype(previousSection);

      if (subtype === 'HeroNoText') {
        gapHeight = gapHeight * 2; // we double the gap height is it applied x1 at the end of the function
      }
    }
  }

  viewData.layoutTable?.forEach(
    pushGapToColumn(gapHeight / 2, viewData, 'pink')
  );
  return viewData;
}

export function addGapAfterSectionWithSectionId(
  viewData: ViewData,
  section: BrandConcessionContentSectionDTO
): ViewData {
  let gapHeight = getGapHeightWithNextSection(viewData, section);

  // If I'm HeroAndText with Hero image only, then I apply no gap on my bottom padding (all is applied by next section)
  if (section.template === 'HeroAndText') {
    const subtype = getHeroAndTextSubtype(section);

    if (subtype === 'HeroNoText') {
      gapHeight = 0;
    }
  }

  // If I'm not HeroAndText and my next section is HeroAndText with Hero image, then I have to apply all the gap between us
  if (section.template !== 'HeroAndText') {
    const nextSection = getNextSection(viewData, section);

    if (nextSection?.template === 'HeroAndText') {
      const subtype = getHeroAndTextSubtype(nextSection);

      if (subtype === 'HeroNoText' || subtype === 'HeroAndText') {
        gapHeight = gapHeight * 2; // we double the gap height is it applied x1 at the end of the function
      }
    }
  }

  viewData.layoutTable?.forEach(
    pushGapToColumn(gapHeight / 2, viewData, 'pink')
  );
  return viewData;
}
